import "../../../assets/css/earthwooduser.css";
import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, MenuItem, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MUIDataTable from "mui-datatables";
import Leftbar from "../../../elements/Leftbar";
import axios from "axios";
import { API_URL } from "../../../config/global_constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const AssignTemplateUserDetails = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [filters, setFilters] = useState({ user_name: "", is_sent: "", sent_date: null });

  const [openModal, setOpenModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);

  // API call
  const GetAssignTemplateUser = async () => {
    setLoading(true);
    try {
      const payload = {
        user_name: filters.user_name || "",
        is_sent: filters.is_sent || "",
        sent_date: filters.sent_date ? moment(filters.sent_date).format("YYYY-MM-DD") : "",
        page: page + 1,
        per_page: rowsPerPage,
      };

      const response = await axios.post(`${API_URL}bulkEmail/getEmailSendUser`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      const apiData = response.data?.data;
      setTemplates(apiData?.data || []);
      setCount(apiData?.total || 0); // Always use total from API
    } catch (error) {
      console.error("Error fetching template data:", error);
      setTemplates([]);
      setCount(0);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    GetAssignTemplateUser();
  }, [page, rowsPerPage, filters]);

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
    setPage(0);
  };

  // Dynamic rows per page options based on total count
  const getRowsPerPageOptions = () => {
    const baseOptions = [10, 20, 50, 100];
    const options = [];

    for (let option of baseOptions) {
      if (count > option || count === 0) {
        options.push(option);
      } else if (count <= option && options.length === 0) {
        // If count is less than first option, still show at least first option
        options.push(10);
        break;
      }
    }

    // If count is small, ensure we show appropriate options
    if (count > 0 && count <= 10 && !options.includes(count)) {
      return [10];
    }

    return options.length > 0 ? options : [10, 20];
  };

  const columns = [
    {
      name: "user",
      label: "Name",
      options: { customBodyRender: value => value ? `${value.first_name || ""} ${value.last_name || ""}`.trim() : "-" },
    },
    { name: "user", label: "Email", options: { customBodyRender: value => value?.email || "-" } },
    { name: "user", label: "Phone Number", options: { customBodyRender: value => value?.phone_number || "-" } },
    {
      name: "user",
      label: "Created At",
      options: { customBodyRender: value => value?.created_at ? moment(value.created_at).format("DD-MM-YYYY HH:mm") : "-" },
    },
    { name: "is_sent", label: "Sent Status", options: { customBodyRender: value => (value === 1 ? "Sent" : "Not Sent") } },
  ];

  const options = {
    serverSide: true,
    count,
    page,
    rowsPerPage,
    selectableRows: "none",
    filter: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    rowsPerPageOptions: getRowsPerPageOptions(),
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setPage(tableState.page);
      }
      if (action === "changeRowsPerPage") {
        setRowsPerPage(tableState.rowsPerPage);
        setPage(0);
      }
    },
  };

  const handleSidebarClose = () => setShowSidebar(false);

  const handleOpen = (rowData) => {
    setSelectedTemplate(rowData);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setSelectedTemplate(null);
  };

  return (
    <div className="earthwood-layout">
      <div className="leftbar-wrapper">
        <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
      </div>
      <div className="earthwood-user-list" style={{ padding: "20px" }}>
        <Typography gutterBottom style={{ fontSize: "20px" }}>Assigned Templates</Typography>

        <div className="row mb-3">
          <div className="col-12 col-md-4 mb-2 mb-md-0">
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search by User Name"
              value={filters.user_name}
              onChange={e => handleFilterChange("user_name", e.target.value)}
              InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon /></InputAdornment>) }}
              fullWidth
            />
          </div>
          <div className="col-12 col-md-4 mb-2 mb-md-0">
            <TextField
              select
              label="Sent Status"
              variant="outlined"
              size="small"
              value={filters.is_sent}
              onChange={e => handleFilterChange("is_sent", e.target.value)}
              fullWidth
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="1">Sent</MenuItem>
              <MenuItem value="0">Not Sent</MenuItem>
            </TextField>
          </div>
          <div className="col-12 col-md-4">
            <DatePicker
              selected={filters.sent_date}
              onChange={date => handleFilterChange("sent_date", date)}
              dateFormat="yyyy-MM-dd"
              placeholderText="Select Sent Date"
              customInput={<TextField variant="outlined" size="small" fullWidth InputProps={{ style: { cursor: 'pointer' } }} />}
            />
          </div>
        </div>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <MUIDataTable
            title={"Assigned Templates List"}
            data={templates}
            columns={columns}
            options={options}
          />
        </Paper>
      </div>
    </div>
  );
}
export default AssignTemplateUserDetails;